import moment from "moment";
import { getAppointmentPhase } from "../enumutils";
import { GooglePlaceState, GroundTransportDateTimeState } from "./groundFields";

export interface NewGroundTransportFormState {
  artist: server.dto.ArtistSmall | undefined
  phase: server.dto.AppointmentPhase
  travellers: server.dto.ContactSmallV2[]
  type: server.dto.GroundTransportType | undefined
  notes: string
  driver: server.dto.Driver

  duration: number

  date: GroundTransportDateTimeState

  startPickupLocationType: server.dto.PickupLocationType | undefined;
  startPickupLocationOther: string;

  endPickupLocationType: server.dto.PickupLocationType | undefined;
  endPickupLocationOther: string;

  startPlace: GooglePlaceState | undefined;
  endPlace: GooglePlaceState | undefined;

  directions: server.dto.GoogleDirections | undefined;
}

export const getInitialNewGroundTransportFormState = (
    serverReference: server.dto.ServerReference,
    artist: server.dto.ArtistSmall | undefined,
    date: moment.Moment | undefined,
): NewGroundTransportFormState => ({
  artist,
  phase: getAppointmentPhase("confirmed", serverReference),
  travellers: [],
  type: undefined,
  notes: "",
  driver: { name: "", mobile: "", email: "", vehicle: "" },
  duration: 0,
  date: {
    departArrive: "departAt",
    dateTime: date ?? moment.utc(),
    inTheNightOf: false,
  },
  startPickupLocationType: undefined,
  startPickupLocationOther: "",
  endPickupLocationType: undefined,
  endPickupLocationOther: "",
  startPlace: undefined,
  endPlace: undefined,
  directions: undefined,
});

// Return type is inferred: the generated CreateGroundTransportInstruction types the
// optional artist/place/direction fields as non-null, but the code passes null for them.
export const getCreateGroundTransportInstruction = (
    state: NewGroundTransportFormState,
    linkToShowId: number | undefined,
) => ({
  artistId: state.artist?.artistId || null,
  dateTime: state.date.dateTime.toDate(),
  departOrArrive: state.date.departArrive,
  driver: state.driver,
  durationInMinutes: state.duration,
  endGooglePlaceAddress: state.endPlace?.address || null,
  endGooglePlaceGeo: state.endPlace?.geo || null,
  endGooglePlaceId: state.endPlace?.placeIdentifier || null,
  endGooglePlaceName: state.endPlace?.name || null,
  endPickupLocation: {
    value: state.endPickupLocationType?.value,
    other: state.endPickupLocationOther,
  },
  linkToShowId: linkToShowId || null,
  groundTransportType: state.type ? state.type.value : "unknown",
  inTheNightOf: state.date.inTheNightOf,
  notes: state.notes,
  phase: state.phase.value,
  directions: {
    polyline: state.directions?.polyline,
    distanceInMeters: state.directions?.distanceInMeters,
    durationEstimateInMinutes: state.directions?.durationEstimateInMinutes,
    status: "",
  },
  startGooglePlaceAddress: state.startPlace?.address || null,
  startGooglePlaceGeo: state.startPlace?.geo || null,
  startGooglePlaceId: state.startPlace?.placeIdentifier || null,
  startGooglePlaceName: state.startPlace?.name || null,
  startPickupLocation: {
    value: state.startPickupLocationType?.value,
    other: state.startPickupLocationOther,
  },
  passengers: state.travellers.map(t => t.contactId),
});
